// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// core plugins needed for page
require('../../../../core/js/plugins/mtc_cookies')

// TODO this needs improved
require('../site_scripts/mtc_read_more')
require('../site_scripts/mtc_load_google_maps_on_demand')
require('../site_scripts/mtc_html5_geolocation')
require('../site_scripts/mtc_directions_form')
require('../site_scripts/mtc_new_dealership_map')
require('../site_scripts/mtc_dealership_map_functions')
require('../site_scripts/mtc_wrap_last_word')
require('../site_scripts/mtc_wrap_first_word')
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')
require('../site_scripts/mtc_sticky_franchise_header')
require('../site_scripts/mtc_mega_menu.js');
require('../site_scripts/mtc_mobile_menu.js');

// functions for old header
require('../site_scripts/mtc_legacy_desktop_menu')
require('../site_scripts/mtc_legacy_mobile_menu')
require('../../../../modules/Search/js/mtc_search')
require('../site_scripts/mtc_show_hide_opening_times')

// carstore / heritage
require('../site_scripts/mtc_slide_out_menu');

// dealerships specific styles
require('../../css/dealerships.less')
